
<template>
  <div>
    <dialog-loading v-if="loading_payments" loadingText='Carregando...'></dialog-loading>

    <v-row class="pa-3" v-if="!loading_payments">
      <v-col cols="6"  class="pb-0">
        <SelectDepot ref="select_depot" list_all></SelectDepot>
      </v-col>
      <v-col cols='6' class="pb-0">
        <v-dialog ref="dialog" :return-value.sync="date" width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-on="on" :value="new Date(date.substring(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR')"
              label="Dia de pagamento" prepend-icon="mdi-calendar" readonly></v-text-field>
          </template>
          <v-date-picker v-model="date" color="primary" locale="pt-br" scrollable>
            <v-spacer></v-spacer>
            <v-btn text icon color="success" @click="$refs.dialog.save(date)"><v-icon>mdi-check</v-icon></v-btn>
            <v-spacer></v-spacer>
          </v-date-picker>
        </v-dialog>
      </v-col>
      
      <v-col cols='12' v-if="!all_payments">
        <v-alert type="info" :value="true">
          Não possui pagamentos nesse dia
        </v-alert>
      </v-col>
      <v-col cols='12' class="pt-0" v-if="all_payments.length" style="font-size: 18px;">
        <div style="border-bottom: solid 0px #ccc; padding: 10px; margin-bottom: 5em;" class="" v-for="(bank, idx) in payments_by_bank" :key="idx">
          <div style="padding: 15px; margin-bottom: 1em; background-color: #ddd;" class="text-left"> <b> {{ bankGroupLabel(idx) }}: </b> {{ genBankAccountResume(idx) }} </div>
          <v-row justify-center>
            <table>
              <thead>
                <th><span style="margin-left: -100px">Motorista</span></th>
                <th>Titular/Documento</th>
                <th>Banco/Conta</th>
                <th>VALOR</th>
              </thead>
              <tbody>
                <tr v-for="(pay, pay_idx) in bank" :key="pay.payment.id">
                  <td style="padding: 15px; margin: 1px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">

                    <v-row class="">
                      <v-col cols="12" class="pa-0 ml-5">
                        #{{ pay_idx+ 1}}- {{ pay.destinable.name }} 
                      </v-col>
                      <v-col cols="12" class="pa-0 ml-5 d-flex flex-column">
                        <span>{{ pay.payment.modality_name }}</span>
                      </v-col>
                    </v-row>

                  </td>
                  <td style="padding: 15px; margin: 1px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">

                    <span>
                      {{ bankAccountAttr(pay, 'name') || '—' }}
                      <br>
                    </span>

                    <b>CPF/CNPJ:</b> {{ bankAccountDoc(pay) }}
                  </td>
                  <td style="padding: 15px; margin: 1px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">
                    {{ bankGroupLabel(idx) }}
                    <br>
                    <b>AG:</b>
                    {{ bankAccountAttr(pay, 'agency') || '—' }}
                    {{ bankAccountAttr(pay, 'digit') ? ('-' + bankAccountAttr(pay, 'digit')) : '' }},
                    <b>Num:</b>
                    {{ bankAccountAttr(pay, 'number') || '—' }}
                    {{ bankAccountAttr(pay, 'account_digit') ? ('-' + bankAccountAttr(pay, 'account_digit')) : '' }},
                    <b>Conta {{ bankAccountType(pay) }}</b>
                  </td>
                  <td style="padding: 15px; margin: 1px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">
                    {{ Number(pay.payment.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                  </td>
                </tr>

              </tbody>
            </table>
          </v-row>
        </div>
      </v-col>

      <v-col cols='12' v-if="all_payments_deposit_missing && all_payments_deposit_missing.length">
        <v-alert type="error" prominent class="mb-3">
          Pagamentos marcados como <b>Depósito</b> precisam ter conta bancária cadastrada.
          Corrija o cadastro do motorista ou o tipo do pagamento.
        </v-alert>
        <div class="headline mb-2">Depósito sem conta cadastrada</div>
        <v-row justify-center>
          <table>
            <thead>
              <th><span style="margin-left: -100px">Motorista</span></th>
              <th>VALOR</th>
              <th>TIPO</th>
            </thead>
            <tbody>
              <tr v-for="(pay, pay_idx) in all_payments_deposit_missing" :key="pay.payment.id">
                <td style="padding: 15px; margin: 15px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">
                  #{{ pay_idx + 1 }}- {{ pay.destinable.name }}
                  <br>
                  <span>{{ pay.payment.modality_name }}</span>
                </td>
                <td style="padding: 15px; margin: 15px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">
                  {{ Number(pay.payment.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                </td>
                <td style="padding: 15px; margin: 15px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">
                  {{ receipt_config_kind_map.deposit }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-row>
      </v-col>

      <v-col cols='12' v-if="all_payments_wout_bank && all_payments_wout_bank.length">
        <div class="headline mb-2">Motoristas sem conta</div>
        <v-row justify-center>
          <table>
            <thead>
              <th><span style="margin-left: -100px">Motorista</span></th>
              <th>VALOR</th>
              <th>TIPO</th>
            </thead>
            <tbody>
              <tr v-for="(pay, pay_idx) in all_payments_wout_bank" :key="pay.payment.id">
                <td style="padding: 15px; margin: 15px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">
                  <v-row class="">
                    <v-col cols="12" class="pa-0 ml-5">
                      #{{ pay_idx+ 1}}- {{ pay.destinable.name }} 
                    </v-col>
                    <v-col cols="12" class="pa-0 ml-5 d-flex flex-column">
                      <span>{{ pay.payment.modality_name }}</span>
                    </v-col>
                  </v-row>

                </td>
                <td style="padding: 15px; margin: 15px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">
                  {{ Number(pay.payment.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }} 
                </td>
                <td style="padding: 15px; margin: 15px; border-top: solid 1px #ddd; border-bottom: solid 1px #ddd">
                  {{ receipt_config_kind_map[receiptKind(pay)] || '—' }}
                  <span v-if="receiptKind(pay) == 'pix'">
                    (
                      <b>Chave {{receipt_config_pix_key_kind_map[pixKeyKind(pay)]}}:</b>
                      {{ pixKey(pay) }}
                    )
                  </span>

                </td>
              </tr>
            </tbody>
          </table>
        </v-row>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import groupby from 'lodash.groupby'
import Api from '@/api/index';
import change_module from "@/mixins/change_module.js"

export default {
  name:"PrintPaymentDriver",
  mixins: [change_module],
  components:{
    SelectDepot: () => import('@/_backoffice/_registrations/components/shared/SelectDepot.vue'),
  },
  data() {
    return {
      receipt_config_kind_map:{
        'cash': 'Dinheiro',
        'deposit': 'Depósito',
        'pix': 'PIX',
        'bill': 'Boleto',
      },
      receipt_config_pix_key_kind_map:{
        'cnpj': 'CNPJ',
        'email': 'E-mail',
        'phone': 'Telefone',
        'random': 'Aleatória',
      },
      search: null,
      date: new Date().toISOString().substring(0, 10),
      by_bank: [],
      payments_by_bank: null,
      all_payments_wout_bank: null,
      all_payments_deposit_missing: [],
      all_payments: [],
      loading_payments: false,
      hover: null,
      headers: [
        { text: 'Titular conta 1', align: 'center', value: 'bank_account_titular' },
        { text: 'Conta Bancária 1', align: 'center', value: 'bank_account_first' },
        { text: 'Conta Bancária 2', align: 'center', value: 'bank_account_second' },
        { text: 'Valor Total (R$)', align: 'center', value: 'ammount' },
      ],
      pagination: {
        page:1,
        itemsPerPage: 50,
        sortBy:['created_at'],
        sortDesc:[true],
        groupBy:[],
        groupDesc:[],
        mustSort:false,
        multiSort:false,
      },
    }
  },
  computed: {
    total_by_bank() {
      if (this.all_payments) {
        let all_trans = this.all_payments //.map(vt=>vt.banks).flat()
        let by_bank = groupby(all_trans, 'banks[0].bank_name')
        let rel = [
        ]
        for (const bank in by_bank) {
          const one_bank_trans = by_bank[bank];

          let total = one_bank_trans.reduce((acc, one) => acc + Number(one.payment.value), 0)
          total = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

          let bk = {
            bank_name: bank,
            qtd: one_bank_trans.length,
            total: total
          }
          rel.push(bk)
        }
        return rel
      }
      return []
    },
    all_vrt_trans() {
      if (this.all_payments) {
        if (this.by_bank.length) {
          let f = this.by_bank.length == 0 ? [] : this.by_bank
          
          return this.all_payments.filter(vt => vt.banks.filter(b => this.by_bank.includes(b.bank_name)))
        }
        return this.all_payments.map(vt => vt)
      }
      return []
    },
    ...mapState({
      activeModalityId: state => state.App.activeModalityId,
    })
  },
  methods: {
    paymentReceiptKind(pay) {
      return pay?.payment?.current_desination_receipt_kind
        || pay?.payment?.json_attributes?.current_desination_receipt_kind
        || null
    },
    driverReceiptKind(pay) {
      const config = pay?.destinable?.receipt_config
      if (!config) return null
      if (config.kinds?.length) return config.kinds[0]
      return config.kind || null
    },
    isDepositPayment(pay) {
      return this.paymentReceiptKind(pay) === 'deposit'
    },
    receiptKind(pay) {
      return this.paymentReceiptKind(pay) || this.driverReceiptKind(pay)
    },
    hasUsableBankSnapshot(pay) {
      const snap = pay.payment?.json_attributes || {}
      return !!(snap.agency || snap.number)
    },
    currentBankAccount(pay) {
      return pay.banks?.[0] || null
    },
    hasUsableBank(pay) {
      const bank = this.currentBankAccount(pay)
      if (!bank) return false
      return !!(bank.bank_name || bank.name || bank.agency || bank.number)
    },
    hasUsableBankAny(pay) {
      return this.hasUsableBank(pay) || this.hasUsableBankSnapshot(pay)
    },
    isDepositWithBank(pay) {
      return this.isDepositPayment(pay) && this.hasUsableBankAny(pay)
    },
    normalizePaymentRow(pay) {
      if (!this.isDepositPayment(pay) || this.hasUsableBank(pay) || !this.hasUsableBankSnapshot(pay)) {
        return pay
      }
      const snap = pay.payment.json_attributes || {}
      return {
        ...pay,
        banks: [{
          bank_name: snap.bank_name || 'Conta do pagamento',
          name: snap.name,
          agency: snap.agency,
          digit: snap.digit,
          number: snap.number,
          account_digit: snap.account_digit,
          CPF: snap.CPF,
          CNPJ: snap.CNPJ,
          current_account: snap.current_account,
        }],
      }
    },
    bankAccountAttr(pay, key) {
      const bank = this.currentBankAccount(pay)
      const snapshot = pay.payment.json_attributes || {}
      if (bank?.[key] != null && bank[key] !== '') return bank[key]
      if (snapshot[key] != null && snapshot[key] !== '') return snapshot[key]
      return ''
    },
    bankAccountDoc(pay) {
      const bank = this.currentBankAccount(pay)
      const snapshot = pay.payment.json_attributes || {}
      const pickDoc = (cpf, cnpj) => {
        if (cpf && cpf !== '1') return cpf
        if (cnpj && cnpj !== '1') return cnpj
        return ''
      }
      return pickDoc(bank?.CPF, bank?.CNPJ) || pickDoc(snapshot.CPF, snapshot.CNPJ) || '—'
    },
    bankAccountType(pay) {
      const currentAccount = this.bankAccountAttr(pay, 'current_account')
      return currentAccount ? 'Corrente' : 'Poupança'
    },
    bankGroupLabel(idx) {
      if (!idx || idx === 'undefined' || idx === 'null') return 'Sem banco'
      const parts = String(idx).split('-')
      const left = parts[0]
      const right = parts.slice(-1)[0]
      if (!left || left === 'undefined') return right || 'Sem banco'
      return `${left} - ${right}`
    },
    pixKeyKind(pay) {
      return pay.destinable?.receipt_config?.pix_key_kind || pay.payment.json_attributes?.pix_key_kind
    },
    pixKey(pay) {
      return pay.destinable?.receipt_config?.pix_key || pay.payment.json_attributes?.pix_key
    },
    getData(){
      this.getPaymentsToPrint()
    },
    getPaymentsToPrint() {
      if(this.activeModalityId){
        this.loading_payments = true
        let modality = [this.activeModalityId]
        if(this.activeModalityId == -1 && this.$refs?.select_depot){
          modality = this.$refs?.select_depot?.filter_modalities?.map(el=> el.id ) || []
        }
        let params = {
          modality_id: modality,
          start_date: this.$moment(this.date).startOf('day').format('YYYY-MM-DD HH:MM') || this.$moment().startOf('day').format('YYYY-MM-DD HH:MM'),
          end_date: this.$moment(this.date).endOf('day').format('YYYY-MM-DD HH:MM') || this.$moment().endOf('day').format('YYYY-MM-DD HH:MM'),
          kind: ['Driver'],
        }
        Api.InternalPayment.indexPrint(params).then(r => r.data).then(r => {
          const rows = (Array.isArray(r) ? r : []).map(p => this.normalizePaymentRow(p))
          this.all_payments = rows.filter(p => this.isDepositWithBank(p))
          this.all_payments_deposit_missing = rows.filter(p => this.isDepositPayment(p) && !this.hasUsableBankAny(p))
          this.all_payments_wout_bank = rows.filter(p => !this.isDepositPayment(p))
          this.payments_by_bank = groupby(this.all_payments, 'banks[0].bank_name')
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading_payments = false
        })
      }
    },
    genBankAccountResume(bank) {
      const one_bank_trans = this.payments_by_bank[bank];

      let total = one_bank_trans.reduce((acc, one) => acc + Number(one.payment.value), 0)
      total = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      return `${one_bank_trans.length} pagamentos - ${total}`
    },
    genBankAccount(bank_account) {
      if (bank_account) {
        let data3 = [
          bank_account.name,
          `Ag: ${bank_account.agency} ${bank_account.digit ? '-' + bank_account.digit : ''}`,
          `Conta: ${bank_account.number} ${account_digit.digit ? '-' + bank_account.account_digit : ''}`,
          ((bank_account.current_account) ? "Corrente" : "Poupança"),
        ]
        return data3.join(', ')
      }
      return ''
    },
    createVrtFilter({ start, end, statuses, kind }) {
      var now = new Date()
      var date_start = new Date(now.getUTCFullYear() - 1, now.getUTCMonth(), 1).toISOString().substr(0, 10)
      var date_end = new Date(now.getUTCFullYear(), now.getUTCMonth() + 3, 1).toISOString().substr(0, 10)

      var status = ['Overdue', 'Open']
      var trans_type = 'sh'

      if (start) date_start = start //: date_start = date_start
      if (end) date_end = end
      if (statuses) status = statuses
      if (kind) trans_type = kind


      var opt = {
        'trans_type': trans_type, // TESTES MAIS RAPIDOS
        'status': status,
        'start_date': date_start,
        'end_date': date_end,
        kind: 'payShipping'
      }
      this.indexFinancial({ kind: 'vrt_transactions', filter: opt })
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    date(nv, ov) {
      this.getPaymentsToPrint()
    },
    activeModalityId(nv){
      this.getPaymentsToPrint()
    }
  },
}
</script>

<style>
.hov_grey:hover {
  background-color: #aaa;
}
</style>